import getDateAsMoment from 'utils/getDateAsMoment';

export const areAllChoicesNo = (choices) => {
  if (!choices) return false;

  const {
    choicesCurrentJob,
    choicesAnticipateAJob12Months,
    choicesChildSupportEligible,
    choicesJobLast90Days,
    choicesAlimonyPayments,
    choicesSsi,
    choicesBenefitsSnaps,
    choicesBenefitsDisability,
    choicesBenefitsPension,
    choicesBenefitsFamily,
    choicesPaymentsOnline,
    choicesPaymentsTrust,
    choicesBenefitsRental,
    choicesPaymentsOther,
  } = choices;

  return [
    choicesCurrentJob,
    choicesAnticipateAJob12Months,
    choicesChildSupportEligible,
    choicesJobLast90Days,
    choicesAlimonyPayments,
    choicesSsi,
    choicesBenefitsSnaps,
    choicesBenefitsDisability,
    choicesBenefitsPension,
    choicesBenefitsFamily,
    choicesPaymentsOnline,
    choicesPaymentsTrust,
    choicesBenefitsRental,
    choicesPaymentsOther,
  ].every((choice) => choice?.toLowerCase() === 'no');
};

export const shouldAllowAddOtherIncome = (members, items, maxRecordCount) => {
  const counts = {};
  members.forEach((member) => {
    counts[member.id] = 0;
  });

  items.forEach((record) => {
    const { memberId } = record;
    if (counts[memberId] !== undefined) {
      counts[memberId] += 1;
    }
  });
  return !Object.values(counts).every((counter) => counter === maxRecordCount);
};

export const getDisabledMembers = (items, memberId, maxRecords) => {
  const counts = {};

  items.forEach((record, index) => {
    const { memberId: thisMemberId } = record;

    // Skip counting the last record if it matches currentMemberId
    if (index === items.length - 1 && thisMemberId === memberId) return;

    counts[thisMemberId] = (counts[thisMemberId] || 0) + 1;
  });

  return Object.entries(counts)
    .filter(([_, counter]) => counter === maxRecords)
    .map(([thisMemberId]) => thisMemberId);
};

export const getDefaultValueForMemberId = (item, members, index) => {
  if (item?.memberId?.length) {
    return item.memberId;
  } else if (members?.length && members?.[0]?.id?.length && index === 0) {
    return members[0].id;
  }
  return '';
};

export const getDefaultValuesForIncome = (item) => {
  return {
    ...item,
    payFrequency: item.payFrequency ?? '',
    weeklyAmount: item.weeklyAmount ?? '',
    monthlyAmount: item.monthlyAmount ?? '',
    annualAmount: item.annualAmount ?? '',

    whom: item.whom ?? '',
    startDate: getDateAsMoment(item.startDate),
    endDate: getDateAsMoment(item.endDate),
  };
};

export const getBaseDefaultValues = (item, members, index) => {
  return {
    memberId: getDefaultValueForMemberId(item, members, index),
    isOpen: !!item.isOpen ?? Boolean(index === 0 && !item.isValid),
    totalIncome: item.totalIncome ?? 0,
  };
};
